import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

import { StartPageComponent } from './start-page/start-page.component';
import { FeedbackPageComponent } from './feedback-page/feedback-page.component';
import { QuizQuestionsComponent } from './quiz-questions/quiz-questions.component';
import { ReviewAndSubmitComponent } from './review-and-submit/review-and-submit.component';
import { QuestionFormComponent } from './question-form/question-form.component';

const Components = [
  StartPageComponent,
  FeedbackPageComponent,
  QuizQuestionsComponent,
  ReviewAndSubmitComponent,
  QuestionFormComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: Components,
  exports: Components
})
export class QuizSystemModule { }
